import { Injectable } from '@angular/core';
import { Condition } from '../../_models/condition';
import { GridColor } from '../../_models/grid-color';
import { GridElement } from '../../_models/grid-element';
import { GridElementSubType } from '../../_models/grid-element-subtype';
import { MapService } from '../map/map.service';
import { Config } from '../../config';
import { CableDetails } from '../../_models/cable-details';
import { GridElementRoot } from '../../_models/grid-element-root';
import { ConfigurationService } from '../configuration/configuration.service';
import { CableColor } from "../../_models/cable-color";



@Injectable({
  providedIn: 'root'
})
export class GridElementService {
  private topology: any;
  // private topology = 'tme-lab'; //  Config.TOPOLOGY_ID;

  constructor(private mapService: MapService,
    private configurationService: ConfigurationService
  ) {
    //this.topology = this.configurationService.getConfiguration().TOPOLOGY;

  }

  getGridElementCondition(gridColorTemp: GridColor) {
    const gridColor = new GridColor(+gridColorTemp.gridElementId);
    gridColor.voltage = gridColorTemp.voltage;
    gridColor.voltageGP = gridColorTemp.voltageGP;
    gridColor.frequency = gridColorTemp.frequency;
    gridColor.la = gridColorTemp.la;
    gridColor.laGP = gridColorTemp.laGP;
    gridColor.rpa = gridColorTemp.rpa;
    return gridColor.getHighestCondition();
  }

  getAllTransformerIds() {
    const ids = [];
    const gridElementsJson: string = localStorage.getItem('gridElements');
    if (gridElementsJson) {
      const gridElements: Array<GridElement> = JSON.parse(gridElementsJson);
      gridElements.forEach(gridElement => {
        if (this.mapService.isTrafo(gridElement.elementSubType)) {
          ids.push(+gridElement.gridElementId);
        }
      });
    }
    return ids;
  }

  saveRootNodeId() {
    this.topology = JSON.parse(localStorage.getItem("currentTopology"));
    console.log("call top: " + JSON.stringify(this.topology));
    this.mapService.getRootNode(this.topology).subscribe((gridElementRoot: GridElementRoot) => {
      localStorage.setItem("root", JSON.stringify(gridElementRoot));
    });
  }

  saveRootNodeId2(topologyId: string, date: string) {

    if (date) {
      this.mapService.getRootNodeTimeDependant(topologyId, date).subscribe((gridElementRoot: GridElementRoot) => {
        localStorage.setItem("root", JSON.stringify(gridElementRoot));
      });
    }
    else {
      this.mapService.getRootNode(topologyId).subscribe((gridElementRoot: GridElementRoot) => {
        localStorage.setItem("root", JSON.stringify(gridElementRoot));
      });

    }
  }

  getRootNodeId() {
    const root: GridElementRoot = JSON.parse(localStorage.getItem("root"));
    if (root) {
      return +root.gridElementId;
    } else {
      return undefined;
    }
  }

  getRootNodeType() {
    const root: GridElementRoot = JSON.parse(localStorage.getItem("root"));
    if (root) {
      return root.Type;
    } else {
      return undefined;
    }
  }

  getTopologyId() {
    const root: GridElementRoot = JSON.parse(localStorage.getItem("root"));
    if (root) {
      return root.TopologyId;
    } else {
      return undefined;
    }
  }

  getRootNodeName() {
    const root: GridElementRoot = JSON.parse(localStorage.getItem("root"));
    if (root) {
      return root.internalDsoId;
    } else {
      return undefined;
    }
  }
}
